module.exports = __webpack_public_path__ + "media/images/check-f171808a.svg";